export default function isNotBetween(minDate: any, maxDate: any, selectedDay: any){
    return  minDate!=null && selectedDay.isBefore(minDate, 'day')
        || maxDate!=null && selectedDay.isAfter(maxDate, 'day');
}
